import { render, staticRenderFns } from "./ZdmEditorFeaturesTabs.vue?vue&type=template&id=74a467d0&scoped=true&"
import script from "./ZdmEditorFeaturesTabs.vue?vue&type=script&lang=js&"
export * from "./ZdmEditorFeaturesTabs.vue?vue&type=script&lang=js&"
import style0 from "./ZdmEditorFeaturesTabs.vue?vue&type=style&index=0&id=74a467d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a467d0",
  null
  
)

export default component.exports